import { styled } from '@ori-ui/mui';
export var Root = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 600,
  margin: 'auto'
});
//# sourceMappingURL=styles.js.map